import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2017e2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Please select all issues that apply to your case. To help us diagnose the problem, the current room's state will be collected and sent along with this report. ", -1))
const _hoisted_3 = { class: "footer-setting" }
const _hoisted_4 = ["disabled"]

import { ref, computed } from 'vue'
import ReportProblemForm from '@/components/room/ReportProblemForm.vue'
import useSpaceApi from '@/composables/api/useSpaceApi'

interface ReportProblemPopupEmits {
  (e: 'update:modelValue', value: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportProblemPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {



const emit = __emit
const { saveLogsReport } = useSpaceApi()
const other = ref('')
const checkedIssues = ref([])
const reportProblemPayload = computed(() => [
  ...checkedIssues.value,
  ...(other.value.trim() !== '' ? [`[99] ${other.value.trim()}`] : []),
])
const disabled = computed(() => (reportProblemPayload.value.length === 0 ? true : false))
const submit = async () => {
  emit('update:modelValue', false)
  await saveLogsReport(reportProblemPayload.value)
  checkedIssues.value = []
}
const close = () => {
  emit('update:modelValue', false)
  checkedIssues.value = []
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Report Problem",
    open: __props.modelValue,
    width: "500",
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          disabled: disabled.value,
          type: "button",
          class: "btn btn-primary ml-3",
          onClick: submit
        }, " Submit ", 8, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          onClick: close
        }, "Cancel")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(ReportProblemForm, {
          modelValue: checkedIssues.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkedIssues).value = $event)),
          other: other.value,
          "onUpdate:other": _cache[1] || (_cache[1] = ($event: any) => ((other).value = $event))
        }, null, 8, ["modelValue", "other"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})